module.exports = __webpack_public_path__ + "img/1F1E8-1F1F7.c6854f67.svg";